import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavbarComponent } from '../navigation/top-navbar/top-navbar.component';
import { BottomNavbarComponent } from '../navigation/bottom-navbar/bottom-navbar.component';
import { TableComponent as StepTableComponent } from '../steps/table/table.component';
import { CommentsComponent } from '../comments/comments.component';
import { ExplorerComponent } from '../files/explorer/explorer.component';
import { TableModule } from 'primeng/table';
import {PickListModule} from 'primeng/picklist';
import { RouterModule } from '@angular/router';

import {NgxFilesizeModule} from 'ngx-filesize';
import { NgxFileDropModule } from 'ngx-file-drop';

import {ProgressBarModule} from 'primeng/progressbar';
import {SkeletonModule} from 'primeng/skeleton';
import { PipesModule } from '../../pipes/pipes.module'

import { FormsModule } from '@angular/forms';
import {MultiSelectModule} from 'primeng/multiselect';
import {SearchItemComponent} from '../search/item/item.component';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
  declarations: [
    TopNavbarComponent,
    BottomNavbarComponent,
    StepTableComponent,
    CommentsComponent,
    ExplorerComponent,
    SearchItemComponent,
    
    
  ],
  imports: [
    RouterModule,
    CommonModule,
    TableModule,
    PickListModule,
    ProgressBarModule,
    SkeletonModule,
    PipesModule,
    FormsModule,
    NgxFilesizeModule,
    NgxFileDropModule,
    MultiSelectModule,
    DropdownModule
  ],
  exports: [
    TopNavbarComponent,
    BottomNavbarComponent,
    StepTableComponent,
    CommentsComponent,
    ExplorerComponent,
    SearchItemComponent
  ]
})
export class SharedModule { }
